// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__z3-DD","footer":"ModalCreateQualiphyProcedure_footer__3ghoB","additionData":"ModalCreateQualiphyProcedure_additionData__1tNRj"};